// extracted by mini-css-extract-plugin
export default {"OrdHodPersonal":"OrdHodPersonal_OrdHodPersonal__GdBwu","ordHodAKontakt":"OrdHodPersonal_ordHodAKontakt__7+Doj"};